import { VARIABLES } from "../../Environments/constants";
import { ServiceUtils } from "./ServiceUtils";
import { sessionService } from "./SessionService";
import { alertService } from "./ToasterUtils";

function titleCase(text) {
  const input = text || '';
  const temp = input.replaceAll('-', ' ');
  const ar = temp.split(' ').map(el => {
    let t = '';
    t += el.charAt(0).toUpperCase();
    t += el.substr(1);
    return t;
  })
  return ar.join(' ');
}

function htmlToText(content) {
  let tag = document.createElement('div');
  tag.id = 'text2html';
  tag.innerHTML = content;
  return tag.innerText;
}

function isEmpty(value) {
  return value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '');
};

function fetchList(key, callback) {
  ServiceUtils.getRequest(`list-${key}`,  false).then(
    _response => {
      if (_response.status === 200) {
        if (_response.data.status === 'Success') {
          if (typeof callback === 'function') callback(_response.data)
        } else {
          alertService.error(_response.data.message || `Error while fetching ${key} list`);
        }
      } else {
        alertService.error(_response?.data?.message || _response.message || 'Internal Server Error');
      }
    }
  );
}


function fetchListPost(key, payload, callback) { 
  ServiceUtils.postRequest(key, payload).then(
    _response => {
      if (_response.status === 200) {
        if (_response.data.status === 'Success') {
          if (typeof callback === 'function') callback(_response.data)
        } else {
          alertService.error(_response.data.message || `Error while fetching list`);
        }
      } else {
        alertService.error(_response?.data?.message || _response.message || 'Internal Server Error');
      }
    }
  );
}

const checkAccess = access => { // ['admin', 'lead']
  const role = sessionService.getSession()?.[VARIABLES.userRole]; // ['Admin', 'Lead']
  return (Array.isArray(access) && Array.isArray(role) && role?.filter(el => access?.includes(el?.toLowerCase()))?.length > 0);
}

function deepClone(object) {
  return JSON.parse(JSON.stringify(object));
}

function tableToCSV(fileName) {
 
  // Variable to store the final csv data
  var csv_data = [];

  // Get each row data
  var rows = document.getElementsByTagName('tr');
  for (var i = 0; i < rows.length; i++) {
      // Get each column data
      var cols = rows[i].querySelectorAll('td,th');
      // Stores each csv row data
      var csvrow = [];
      for (var j = 0; j < cols.length; j++) {

          // Get the text data of each cell
          // of a row and push it to csvrow
          if(!cols[j].innerHTML.includes("<div"))
          csvrow.push(cols[j].innerHTML);
      }

      // Combine each column value with comma
      csv_data.push(csvrow.join(","));
  }

  // Combine each row data with new line character
  csv_data = csv_data.join('\n');

  // Call this function to download csv file 
  downloadCSVFile(csv_data,fileName);

}

function downloadCSVFile(csv_data,fileName) {

  // Create CSV file object and feed
  // our csv_data into it
  let CSVFile = new Blob([csv_data], {
      type: "text/csv"
  });

  // Create to temporary link to initiate
  // download process
  var temp_link = document.createElement('a');

  // Download csv file
  temp_link.download = `${fileName}.csv`;
  var url = window.URL.createObjectURL(CSVFile);
  temp_link.href = url;

  // This link should not be displayed
  temp_link.style.display = "none";
  document.body.appendChild(temp_link);

  // Automatically click the link to
  // trigger download
  temp_link.click();
  document.body.removeChild(temp_link);
}

function searchTable(searchText, body, header) {
  let searchColumns = [];
  if (Array.isArray(header)) {
    searchColumns = header.map(el => el?.key);
  }
  const result = body.filter(row =>
    searchColumns.filter(key => row?.[key]?.toString()?.toLowerCase()?.includes(searchText?.toString()?.toLowerCase()))?.length > 0
  );
  return result;
}

const textEllipsis = (str, maxLength, { side = "end", ellipsis = "..." } = {}) => {
  let data;
  if (Array.isArray(str)) {
    data = str[0];
  }
  else
    data = str;
  if (data?.length > maxLength) {
    switch (side) {
      case "start":
        return ellipsis + data?.slice(-(maxLength - ellipsis.length));
      case "end":
      default:
        return data?.slice(0, maxLength - ellipsis.length) + ellipsis;
    }
  }
  return data;
}

const getCountPercent = (content) => {
  const keys = Object.keys(content);
  let total = 0;
  let escalated = 0;
  keys.forEach(key => {
      if (content[key].label !== "Escalated") {
          total = total + content[key].count;
      }
      else {
          escalated = escalated + content[key].count;
      }
  })
  const perCentValue = (escalated - total) ;
  if (perCentValue > 0) {
      return true;
  }
  else {
      return false;
  }
}

const handleLogout = () => {
  let payload;
  const userDetails = sessionService.getSession("cpcb-user");
  if (userDetails) payload = {};
  const encodedPayload = btoa(JSON.stringify(payload));
  ServiceUtils.postRequest("userLogout", encodedPayload).then((_response) => {
    let decodedData;
    if (_response?.data) {
      decodedData = JSON.parse(atob(_response.data));
    }
    if (_response.status === 200) {
      if (decodedData?.status === "failed") {
        alertService.error("Logout Error")
      } else {
        // history.push("/logout");
      }
    } else {
      alertService.error(
        decodedData?.data?.message ||
          decodedData?.message ||
          "Internal Server Error"
      );
    }
  });
};




export {
  titleCase,
  htmlToText,
  fetchList,
  fetchListPost,
  isEmpty,
  deepClone,
  checkAccess,
  searchTable,
  textEllipsis,
  handleLogout,
  tableToCSV,
  getCountPercent
};